import { Card, Space } from "antd";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import styles from "./Wishlist.module.scss";
import { Button, Drawer } from "antd";
import { ExternalLink } from "react-feather";
import drawerStyles from "./ProductDrawer.module.scss";
import { fetchWishlist } from "../../../../api/wishlist.api";
import { BackwardOutlined, LeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { LogEvents, LoggerContext } from "../../../../context/logging";

export const VariantDrawer = (props) => {
  return (
    <Drawer
      title="Product Details"
      placement="right"
      onClose={() => props.setVariant(null)}
      visible={!!props.variant}
    >
      <section className={drawerStyles.container}>
        <div
          className={drawerStyles.image}
          style={{
            backgroundImage: `url("${props.variant?.images[0]?.imageUrl}")`,
          }}
        />
        <div className={drawerStyles.vendor}>{props.product?.vendorName}</div>
        <div className={drawerStyles.title}>{props.product?.title}</div>
        <a
          className={drawerStyles.items}
          href={`https://materialdepot.in/${props.variant?.productId?.$oid}-product`}
          target="_blank"
          rel="noreferrer"
        >
          <div className={drawerStyles.item}>
            <span className={drawerStyles.label}>Specification</span>
            <span className={drawerStyles.icon}>
              <ExternalLink />
            </span>
          </div>
          <div className={drawerStyles.item}>
            <span className={drawerStyles.label}>Weight & Dimensions</span>
            <span className={drawerStyles.icon}>
              <ExternalLink />
            </span>
          </div>
          <div className={drawerStyles.item}>
            <span className={drawerStyles.label}>Description</span>
            <span className={drawerStyles.icon}>
              <ExternalLink />
            </span>
          </div>
        </a>
        <a
          href={`https://materialdepot.in/${props.variant?.productId?.$oid}-product`}
          target="_blank"
          rel="noreferrer"
          className={styles.button}
        >
          <Button type="primary" className={drawerStyles.button} size="large">
            View Product
          </Button>
        </a>
      </section>
    </Drawer>
  );
};

export const VariantProduct = (props) => {
  return (
    <Card
      loading={props.loading}
      style={{ height: 350 }}
      cover={
        props.product && (
          <div className={styles.imageContainer}>
            <img
              alt={props.product?.images[0]?.imageAltText}
              src={props.product?.images[0]?.imageUrl}
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        )
      }
      hoverable
      onClick={() => props.setActiveVariant(props.product)}
    >
      <Card.Meta
        title={props.product?.productName}
        description={props.product?.vendorName}
      />
    </Card>
  );
};

const Wishlist = (props) => {
  const {
    settings: { project },
  } = props;
  const [activeVariant, setActiveVariant] = React.useState(null);
  const [wishlist, setWishlist] = React.useState([]);
  const navigate = useNavigate();
  const logger = React.useContext(LoggerContext);

  const getWishlistedItems = () => {
    fetchWishlist(project?.id).then((res) => {
      setWishlist(res);
    });
  };

  useEffect(() => {
    getWishlistedItems();
    logger.log(LogEvents.viewWishlist, {});
  }, []);

  return (
    <>
      <VariantDrawer variant={activeVariant} setVariant={setActiveVariant} />
      <Space align="center" style={{ marginBottom: "1.5rem" }}>
        <LeftOutlined
          style={{ cursor: 'pointer' }} 
          onClick={() => navigate("/app/ecommerce/product")}
        />
        <h1 style={{ marginBottom: 0 }}>Wishlist items</h1>
      </Space>
      <div className={styles.grid}>
        {wishlist?.map((product) => (
          <VariantProduct
            key={product?.product_id?.$oid}
            product={product}
            setActiveVariant={setActiveVariant}
            loading={false}
          />
        ))}
      </div>
    </>
  );
};

const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});

export default connect(mapStateToProps)(Wishlist);
